import {
  LOAD_DISCUSSIONS,
  LOAD_DISCUSSIONS_SUCCESS,
  LOAD_DISCUSSIONS_ERROR,
  SET_RELOAD_DISCUSSIONS,
  CLEAR_DISCUSSIONS,
  RELOAD_DISCUSSIONS,
} from './constants';

export function loadingDiscussions(campaignId) {
  return {
    type: LOAD_DISCUSSIONS,
    campaignId,
  };
}

export function reloadDiscussions(data) {
  return {
    type: RELOAD_DISCUSSIONS,
    data
  };
}

export function loadDiscussionsError(error) {
  return {
    type: LOAD_DISCUSSIONS_SUCCESS,
    error,
  };
}

export function loadingDiscussionsSuccess(discussions) {
  return {
    type: LOAD_DISCUSSIONS_ERROR,
    discussions,
  };
}

export function setReloadDiscussions(reloadDiscussions) {
  return {
    type: SET_RELOAD_DISCUSSIONS,
    reloadDiscussions,
  };
}

export function clearDiscussions() {
  return {
    type: CLEAR_DISCUSSIONS,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/discussion-list/actions.js
 **/